import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Form, Input, Button, DatePicker, Select, InputNumber, Space } from 'antd';
import moment from 'moment';
import ManagerService from '../../services/ManagerService';

const { Option } = Select;

const TaoDonCongNoComponent = () => {
  // Lấy thông tin user từ localStorage
  const username = localStorage.getItem('username') || '50560';
  const name = localStorage.getItem('name') || 'Nguyễn Trọng Huấn';

  // State lưu danh sách khách hàng (mảng chứa { ma_khach_hang, ten_don_vi })
  const [dsKhachHang, setDsKhachHang] = useState([]);

  // Sử dụng form antd
  const [form] = Form.useForm();

  // Gọi API lấy danh sách khách hàng từ bảng don_vi_kinh_doanh
  useEffect(() => {
    const fetchDsKhachHang = async () => {
      try {
        const response = await ManagerService.getDonViKinhDoanh();
        if (response.success) {
          setDsKhachHang(response.data);
        }
      } catch (error) {
        console.error('Lỗi khi lấy DS khách hàng:', error);
      }
    };
    fetchDsKhachHang();
  }, []);

  // Khi người dùng chọn Mã KH, tự động cập nhật Tên đơn vị
  const handleCustomerChange = (value) => {
    const selected = dsKhachHang.find((kh) => kh.ma_khach_hang === value);
    form.setFieldsValue({ ten_don_vi: selected ? selected.ten_don_vi : '' });
  };

  const onFinish = async (values) => {
    // values.ky_ps là đối tượng moment; chuyển thành chuỗi định dạng YYYY-MM sau đó gắn thêm "-01"
    const ky_ps = values.ky_ps.format("YYYY-MM") + "-01";

    // Tạo payload kết hợp các giá trị từ form và thông tin mặc định
    const payload = {
      don_vi: values.don_vi, // trường ẩn
      ky_ps,
      dich_vu: values.dich_vu,
      ma_nv: values.ma_nv,   // trường ẩn
      tuyen_sale: values.tuyen_sale, // trường ẩn
      ma_khach_hang: values.ma_khach_hang,
      ten_don_vi: values.ten_don_vi,
      ma_hd: values.ma_hd,
      tong_cong_no: values.tong_cong_no,
      thoi_han_cong_no: parseInt(values.thoi_han_cong_no),
    };

    try {
      const response = await ManagerService.TaoDonCongNo(payload);
      if (response.success) {
        alert('Tạo đơn công nợ thành công!');
        form.resetFields();
      } else {
        alert(response.message || 'Có lỗi khi tạo đơn công nợ');
      }
    } catch (error) {
      alert('Lỗi khi tạo đơn công nợ: ' + error.message);
    }
  };

  return (
    <Container className="my-4">
      <h3 className="mb-4">Tạo Đơn Công Nợ Khách Hàng</h3>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          don_vi: 'CNKT3',
          ma_nv: username,
          tuyen_sale: name,
          thoi_han_cong_no: 30,
        }}
      >
        {/* Các trường ẩn: Đơn vị, Mã NV, Tuyến sale */}
        <Form.Item name="don_vi" hidden>
          <Input />
        </Form.Item>
        <Form.Item name="ma_nv" hidden>
          <Input />
        </Form.Item>
        <Form.Item name="tuyen_sale" hidden>
          <Input />
        </Form.Item>

        {/* Row 1: Kỳ phát sinh */}
        <Form.Item
          label="Kỳ phát sinh"
          name="ky_ps"
          rules={[{ required: true, message: 'Vui lòng chọn kỳ phát sinh' }]}
        >
          <DatePicker picker="month" style={{ width: '100%' }} />
        </Form.Item>

        {/* Row 2: Dịch vụ */}
        <Form.Item
          label="Dịch vụ"
          name="dich_vu"
          rules={[{ required: true, message: 'Vui lòng chọn dịch vụ' }]}
        >
          <Select placeholder="Chọn dịch vụ">
            <Option value="VLC">VLC</Option>
            <Option value="VLK">VLK</Option>
            <Option value="CPN">CPN</Option>
          </Select>
        </Form.Item>

        {/* Row 3: Mã khách hàng */}
        <Form.Item
          label="Mã khách hàng (EVTP)"
          name="ma_khach_hang"
          rules={[{ required: true, message: 'Vui lòng chọn mã khách hàng' }]}
        >
          <Select
            showSearch
            placeholder="Chọn Mã KH"
            onChange={handleCustomerChange}
            // filterOption cho phép lọc theo text người dùng gõ
            filterOption={(input, option) => {
              // Ở đây, ta lọc dựa trên children (nội dung hiển thị) hoặc value
              // Tùy ý bạn điều chỉnh cho phù hợp
              const text = option.children?.toLowerCase() || '';
              return text.includes(input.toLowerCase());
            }}
          >
            {dsKhachHang.map((kh) => (
              <Option key={kh.ma_khach_hang} value={kh.ma_khach_hang}>
                {kh.ma_khach_hang}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Row 4: Tên đơn vị và Mã HĐ */}
        <Form.Item label="Tên đơn vị" name="ten_don_vi">
          <Input readOnly />
        </Form.Item>
        <Form.Item
          label="Mã HĐ"
          name="ma_hd"
          rules={[{ required: true, message: 'Vui lòng nhập mã HĐ' }]}
        >
          <Input placeholder="Nhập mã HĐ" />
        </Form.Item>

        {/* Row 5: Công nợ trên HĐ và Thời hạn công nợ */}
        <Form.Item
          label="Công nợ trên HĐ"
          name="tong_cong_no"
          rules={[{ required: true, message: 'Vui lòng nhập công nợ trên HĐ' }]}
        >
          <InputNumber
            style={{ width: '100%' }}
            placeholder="Nhập số công nợ"
            step="0.01"
            formatter={(value) =>
              value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }
            parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
          />
        </Form.Item>
        <Form.Item
          label="Thời hạn công nợ (ngày)"
          name="thoi_han_cong_no"
          rules={[{ required: true, message: 'Vui lòng chọn thời hạn công nợ' }]}
        >
          <Select placeholder="Chọn thời hạn">
            <Option value="30">30 ngày</Option>
            <Option value="45">45 ngày</Option>
            <Option value="60">60 ngày</Option>
            <Option value="90">90 ngày</Option>
          </Select>
        </Form.Item>

        {/* Nút Submit và Reset */}
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">
              Tạo Đơn Công Nợ
            </Button>
            <Button htmlType="button" onClick={() => form.resetFields()}>
              Làm mới
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default TaoDonCongNoComponent;
